import React from 'react';

import queryString from 'query-string';
import { useLocation, useParams } from 'react-router-dom';

import HeaderActions from '../../../common/headerActions';
import history from '../../../routes/history';

const PreviewWorkflowAction = () => {
  const { id } = useParams<any>();
  const validActions = [{ name: 'Close', style: 'primary', visible: true }];
  const search = useLocation().search;
  const handleActionClick = () => {
    const param = queryString.parse(search);
    if (param.origin === 'detail') {
      history.push(`/workflow/${id}`);
    } else {
      history.push('/workflows');
    }
  };

  return <HeaderActions actions={validActions} handleActionClick={handleActionClick} />;
};

export default PreviewWorkflowAction;
